import { ResetPasswordForm } from "Auth/Components/ResetPasswordForm";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { UnauthenticatedLayout } from "Shared/Layouts/UnauthenticatedLayout";

export const ResetPasswordPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <UnauthenticatedLayout title={t(Resources.ResetPassword.Title)}>
      <ResetPasswordForm />
    </UnauthenticatedLayout>
  );
};
